import { Route, Routes } from 'react-router-dom';
import NewsletterListPage from './list';

export default function NewsletterRouting() {
  return (
    <Routes>
      <Route index element={<NewsletterListPage />} />
    </Routes>
  );
}